import React from 'react'
import PropTypes from 'prop-types'
import history from 'browserHistory'

import { Text, Button } from 'components/base'
import RoutesHelper from 'helpers/RoutesHelper'

class IntegrationEntry extends React.PureComponent {
  static propTypes = {
    name: PropTypes.string.isRequired,
    canManage: PropTypes.bool.isRequired,
    photoURL: PropTypes.string.isRequired,
    clientId: PropTypes.string.isRequired,
  }

  handleManageClick = event => {
    event.preventDefault()

    history.push(
      RoutesHelper.settingsIntegrationApplicationDetails({
        applicationId: this.props.clientId,
      })
    )
  }

  render() {
    const { name, photoURL } = this.props

    return (
      <section className="integration-entry">
        <div
          className="flexbox flexbox-align-center padding-medium background-shade-100 background-shade-50-on-hover radius-large"
          style={{ minWidth: 500 }}
        >
          <img src={photoURL} alt="application logo" height={35} width={35} />
          <div className="flexbox-grow margin-horizontal-medium">
            <Text.Corpus>{name}</Text.Corpus>
          </div>
          <Button.Secondary onClick={this.handleManageClick}>
            Manage
          </Button.Secondary>
        </div>
      </section>
    )
  }
}

export default IntegrationEntry
